import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import LoadingSpinner from "@/components/LoadingSpinner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  getPayoutHistory,
  MentorPayoutsKeys,
} from "@/features/payouts/api/mentor-payouts";

const formatCurrencyAmount = (amount: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

const PayoutHistoryTable = () => {
  const { data = [], isLoading } = useQuery({
    queryKey: [MentorPayoutsKeys.GET_PAYOUT_HISTORY],
    queryFn: getPayoutHistory,
  });

  if (isLoading) {
    return (
      <Card className="p-8 flex items-center justify-center">
        <LoadingSpinner />
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Payout History</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Mentor Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead className="text-right">Amount</TableHead>
              <TableHead className="text-right">Payments</TableHead>
              <TableHead>Period</TableHead>
              <TableHead>Created At</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={6}
                  className="text-center text-muted-foreground"
                >
                  No payout history found
                </TableCell>
              </TableRow>
            ) : (
              data.map((payout) => (
                <TableRow key={payout.payoutId}>
                  <TableCell className="font-medium">
                    {payout.mentorName}
                  </TableCell>
                  <TableCell>{payout.mentorEmail}</TableCell>
                  <TableCell className="text-right">
                    {formatCurrencyAmount(payout.amountUsd)}
                  </TableCell>
                  <TableCell className="text-right">
                    {payout.paymentsCount}
                  </TableCell>
                  <TableCell>
                    {format(new Date(payout.startDate), "MMM d, yyyy")} –{" "}
                    {format(new Date(payout.endDate), "MMM d, yyyy")}
                  </TableCell>
                  <TableCell>
                    {format(new Date(payout.createdAt), "MMM d, yyyy")}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default PayoutHistoryTable;
